import React, { useEffect, useRef } from 'react';

function Portfolio() {
    const cardsRef = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        cardsRef.current.forEach(card => {
            if (card) {
                card.style.opacity = '0';
                card.style.transform = 'translateY(30px)';
                card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                observer.observe(card);
            }
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section id="portfolio" className="section portfolio-section">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">PORTFOLIO</span>
                    <h2 className="section-title">주요 프로젝트</h2>
                    <p className="section-description">
                        GraceTech와 IF가 함께 완성한 성공 사례
                    </p>
                </div>
                
                <div className="portfolio-grid">
                    <div className="portfolio-card" ref={el => cardsRef.current[0] = el}>
                        <div className="portfolio-image">
                            <div className="portfolio-placeholder">
                                <i className="fas fa-microchip"></i>
                            </div>
                            <div className="portfolio-overlay">
                                <span className="portfolio-tag">하드웨어</span>
                            </div>
                        </div>
                        <div className="portfolio-content">
                            <h3>산업용 제어 보드</h3>
                            <p>고성능 산업용 제어 시스템을 위한 다층 PCB 설계 및 양산</p>
                            <div className="portfolio-tech">
                                <span className="tech-tag">Multi-layer PCB</span>
                                <span className="tech-tag">SMT</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="portfolio-card" ref={el => cardsRef.current[1] = el}>
                        <div className="portfolio-image">
                            <div className="portfolio-placeholder">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <div className="portfolio-overlay">
                                <span className="portfolio-tag">통합 솔루션</span>
                            </div>
                        </div>
                        <div className="portfolio-content">
                            <h3>스마트 IoT 디바이스</h3>
                            <p>하드웨어 개발과 모바일 앱 연동을 통한 IoT 제품 완성</p>
                            <div className="portfolio-tech">
                                <span className="tech-tag">IoT</span>
                                <span className="tech-tag">Mobile App</span>
                                <span className="tech-tag">BLE</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="portfolio-card" ref={el => cardsRef.current[2] = el}>
                        <div className="portfolio-image">
                            <div className="portfolio-placeholder">
                                <i className="fas fa-heartbeat"></i>
                            </div>
                            <div className="portfolio-overlay">
                                <span className="portfolio-tag">의료기기</span>
                            </div>
                        </div>
                        <div className="portfolio-content">
                            <h3>의료 측정 장비</h3>
                            <p>고정밀 센서 보드 및 데이터 처리 소프트웨어 개발</p>
                            <div className="portfolio-tech">
                                <span className="tech-tag">High-precision</span>
                                <span className="tech-tag">Firmware</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="portfolio-card" ref={el => cardsRef.current[3] = el}>
                        <div className="portfolio-image">
                            <div className="portfolio-placeholder">
                                <i className="fas fa-car"></i>
                            </div>
                            <div className="portfolio-overlay">
                                <span className="portfolio-tag">자동차</span>
                            </div>
                        </div>
                        <div className="portfolio-content">
                            <h3>차량용 전장 시스템</h3>
                            <p>자동차 산업 표준을 만족하는 고신뢰성 PCB 및 제어 시스템</p>
                            <div className="portfolio-tech">
                                <span className="tech-tag">Automotive</span>
                                <span className="tech-tag">ADAS</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Portfolio;
